import axios from 'axios'
const chromeLang = localStorage.getItem('lang') || navigator.language.substr(0, 2)
export function getLang(lang?) {
  const language = lang || chromeLang === 'zh' ? 'zh' : 'en'
  return axios.get(`/vshow-main/lang/${language}.json?time=${new Date().getTime()}`)
}
